import { render, staticRenderFns } from "./exchange-log.vue?vue&type=template&id=7963dc36&scoped=true"
import script from "./exchange-log.vue?vue&type=script&lang=js"
export * from "./exchange-log.vue?vue&type=script&lang=js"
import style0 from "./exchange-log.vue?vue&type=style&index=0&id=7963dc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963dc36",
  null
  
)

export default component.exports